import { Grid } from "@material-ui/core";
import { billingDashboardStyle } from "./style";
import ExportButton from "components/ExportButton/ExportButton";

const GraphHeader = ({ title, mapExportData, data }) => {
    const classes = billingDashboardStyle();

    return (
        <Grid container justifyContent='space-between'>
            <Grid item>
                <h3 className={classes.graphHeader}>
                    {title}
                </h3>
            </Grid>
            {!!mapExportData && <Grid item> <ExportButton label='Export' mapExportData={mapExportData} data={data} /></Grid>}
        </Grid>
    )
}
export default GraphHeader;